import {
  FETCH_PRODUCTS,
  FETCH_PRODUCT,
  CREATE_PRODUCT,
  DELETE_PRODUCT,
} from '../types';

export const productReducers = (state = {}, action) => {
  switch (action.type) {
    case FETCH_PRODUCTS:
      return { ...state, items: action.payload };
    case CREATE_PRODUCT:
      return { ...state, items: action.payload };
    case FETCH_PRODUCT:
      return { ...state, product: action.payload };
    case DELETE_PRODUCT:
      return { ...state, items: action.payload };
    default:
      return state;
  }
};
